import NavMenu from './nav-menu'

export default NavMenu
